export default __webpack_public_path__ + "images/c76913757a5ebc770eda671fcd1f921d.svg";